export const GRID_TREE_NODE_TYPE = Symbol('treeNode');
